import { Button } from "@/components/ui/button";
import { Linkedin } from "lucide-react";
import founderImg from "@/assets/founder-obrist-buasa.jpg";

export function FounderFull() {
  return (
    <section id="founder" className="py-20 md:py-28 scroll-mt-24">
      <div className="mx-auto max-w-5xl px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-wider uppercase text-primary mb-3">
            Meet the Founder
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-foreground">
            Built with purpose, faith, and service
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[260px_1fr] gap-10 md:gap-14 items-start">
          <div className="mx-auto md:mx-0">
            <div className="relative h-60 w-60 overflow-hidden border border-border bg-muted">
              <img
                src={founderImg}
                alt="Obrist Buasa, Founder of Heallexa"
                className="h-full w-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          <div>
            <h3 className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground">
              Obrist Buasa
            </h3>
            <p className="text-sm text-muted-foreground mt-1 mb-6">Founder of Heallexa</p>

            <div className="space-y-4 text-base text-foreground/80 leading-relaxed">
              <p>
                Obrist Buasa is the Founder of Heallexa, an AI powered healthcare search
                platform created to make it easier for patients to find healthcare providers by
                specialty, location, insurance, and availability.
              </p>
              <p>
                Born in the Democratic Republic of Congo, Obrist moved to the United States in
                2011 and has built his journey around service, leadership, faith, and
                entrepreneurship. He holds a Bachelor's Degree in Business Administration and
                served in the United States Army from 2015 to 2019.
              </p>
              <p>
                In addition to his business background, Obrist is a graduate of the Reinhard
                Bonnke School of Evangelism and is a Gospel preacher. His life and work are
                shaped by a strong commitment to service, purpose, and helping people access
                better opportunities. He is married and a proud father of three children.
              </p>
              <p>
                Through Heallexa, Obrist's mission is to help patients search for care more
                easily while giving healthcare providers and practices a simple way to manage
                their online presence, claim their profiles, and receive appointment requests.
              </p>
            </div>

            <Button asChild className="mt-8">
              <a
                href="https://www.linkedin.com/in/obristbuasa/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin className="mr-2 h-4 w-4" /> Connect on LinkedIn
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
